import React from "react";
import { announcements } from "../mock";

export default function AnnouncementBar() {
  const items = [...announcements, ...announcements, ...announcements];
  return (
    <div className="w-full bg-[#1a1a1a] text-[#FBF8F4] py-2.5 overflow-hidden">
      <div className="announcement-track whitespace-nowrap">
        {items.map((t, i) => (
          <span
            key={i}
            className="font-sans-y text-[11px] tracking-[0.25em] uppercase font-medium px-6 flex items-center"
          >
            <span className="text-[#C9A961] mr-6">✦</span>
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
